import React from 'react';
import { Wifi, AlertCircle, Loader2 } from 'lucide-react';
import { useLoadingMonitor } from '../hooks/useLoadingMonitor';

export function LoadingMonitorBanner() {
  const { loadingState } = useLoadingMonitor();

  // Don't show anything if loading is normal
  if (!loadingState.isSlow && !loadingState.isStuck) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm">
      {loadingState.isStuck ? (
        <div className="bg-red-50 border border-red-200 rounded-lg shadow-lg p-4 flex items-start space-x-3">
          <AlertCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-medium text-red-900">
              Connection Issue
            </p>
            <p className="text-xs text-red-700 mt-1">
              Some requests are taking unusually long. Please check your connection.
            </p>
            {loadingState.requestCount > 0 && (
              <p className="text-xs text-red-600 mt-1">
                {loadingState.requestCount} request{loadingState.requestCount > 1 ? 's' : ''} in progress
              </p>
            )}
          </div>
        </div>
      ) : loadingState.isSlow ? (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg shadow-lg p-4 flex items-start space-x-3">
          <Loader2 className="h-5 w-5 text-yellow-600 flex-shrink-0 mt-0.5 animate-spin" />
          <div className="flex-1">
            <p className="text-sm font-medium text-yellow-900">
              Slow Connection
            </p>
            <p className="text-xs text-yellow-700 mt-1">
              Requests are taking longer than usual. The app is still working...
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
}
